<div class="message-container">
   <div *ngIf="currentAssignedMail; let messageInfo" class="sam-form-flex-row">
      <div>
         <samweb-skill-short-info
            [skills]="messageInfo?.skill?.skills"
            [skillConfiguration]="messageInfo?.skill?.skillConfiguration"
         >
         </samweb-skill-short-info>
         <div class="main-text">
            {{ messageInfo.subject }}
         </div>
         <div class="sub-text">
            {{ messageInfo.address }}
         </div>
      </div>
   </div>
</div>
<button kendoButton (click)="openMail()" class="message-button dial-control-accept">
   <div class="sam-center sam-wiggle">
      <fa-icon [icon]="openMessageIcon" size="2x"></fa-icon>
   </div>
</button>
